import i18n, { setLocale } from '~/utils/i18n';
import Debug from '~/utils/debug';
import * as adapi from '~/utils/adapi';
import * as storeActions from '~/store/actions';
import * as storeGetters from '~/store/getters';
import * as permissions from '~/utils/permissions';
import * as apiKeyPersistance from '~/utils/apikey-persistance';
import { LOGIN_TYPES } from '~/utils/constants';

const debug = Debug('auth');

export function updateUser() {
  return adapi.get('users/current')
    .then(user => storeActions.setCurrentUser(user).then(() => user))
    .then(user => {
      if (user.selected_language) {
        setLocale(user.selected_language);
      }
      return user;
    });
}

export function logout(redirect = true) {
  debug.info('logout');
  const loginType = storeGetters.loginType() || LOGIN_TYPES.EMAIL;
  let logoutUrl = 'auth/logout';
  if (loginType === LOGIN_TYPES.SSO) {
    logoutUrl = 'auth/remote/logout';
  }

  const body = { redirectUrl: `${window.location.origin}/login` };
  return adapi.post(logoutUrl, null, body)
    .then(result => Promise.all([
      storeActions.setApiKey(null),
      apiKeyPersistance.save(null),
      storeActions.setCurrentUser(null),
      storeActions.setLoginType(null),
    ]).then(() => {
      if (result.redirect) {
        window.location.href = result.redirect;
      } else if (redirect) {
        window.location.href = '/login';
      }
    })).catch(error => {
      debug.error(error);
      storeActions.setApiKey(null);
      apiKeyPersistance.save(null);
      storeActions.setCurrentUser(null);
      storeActions.setLoginType(null);
    });
}

export function canUserUsePlatform(user) {
  const requiredPermissions = storeGetters.getLoginPermissions();
  if (!permissions.canGlobal(user, 'User', requiredPermissions)) {
    throw i18n.t('pos.login.no-permissions');
  }
}

export function setJWTToken(token, remember = false) {
  return storeActions.setApiKey(token)
    .then(() => apiKeyPersistance.save(token, remember))
    .then(() => updateUser())
    .then(canUserUsePlatform)
    .catch(err => {
      logout(false);
      throw err;
    });
}

export function login(email, password, remember = false) {
  debug.info('trying to login as %s', email);

  return adapi.post('auth/login', null, { email, password })
    .then(key => setJWTToken(key, remember));
}

export function loginToken(token) {
  debug.info('trying to login with token %s', token);

  return adapi.post('auth/login-token', null, { token })
    .then(setJWTToken);
}
export function tryLoginFromCookie() {
  const storedKey = apiKeyPersistance.load();

  if (storedKey && !storeGetters.apiKey()) {
    return setJWTToken(storedKey)
      .catch(err => {
        debug.warn('Error while getting user by stored key: %o', err);
        storeActions.setApiKey(null);
        throw err;
      });
  }

  return Promise.reject('no stored key or apikey is already set');
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/auth.js